export const environment = {
  production: true,
  reportManagerUrl: 'https://rptmanager.clavisco.com/',
  apiUrl: navigator.onLine ? 'https://emacncsaludapi.clavisco.com/' : 'http://localhost:42222/',
  offlineApiUrl: 'http://localhost:42222/',
  name: 'CNC Salud',
  envType: 'Production',
  description: 'Production environment - CNC Salud',
  appKey: 'AppSuper'
};
